import { useEffect, useState } from 'react';
import { Stack } from '@mui/material';
import { DialogProps } from '../../../interfaces/interfaces';
import { CustomerClient } from '../../../helpers/client';
import { Popup } from '../../popup/popup';
import { AccountConfirmButton } from './accountSettingsStyles';
import { useTranslation } from 'react-i18next';
import { ExternalAuthenticationType } from 'orderme-api-integration-client';
import { useReloginFlow } from '../../../hooks/useReloginFlow';
import { ReloginConfirmation } from '../login/reloginConfirmation';

export interface RevokeLoginDialogProps extends DialogProps {
  externalAuthType: ExternalAuthenticationType;
}

export function ExternalLoginRevoke(props: RevokeLoginDialogProps) {
  const { t } = useTranslation();
  const { onClose, open, externalAuthType: externalLoginType } = props;
  const customersClient: CustomerClient = new CustomerClient();
  const [title, setTitle] = useState<string>();
  const { showReloginDialog, reloginMessage, triggerRelogin, handleReloginConfirm } = useReloginFlow();

  useEffect(() => {
    switch (externalLoginType) {
      case ExternalAuthenticationType.Facebook:
        setTitle(t('account:revokeFacebookLogin'));
        break;
      case ExternalAuthenticationType.Google:
        setTitle(t('account:revokeGoogleLogin'));
        break;
      case ExternalAuthenticationType.Apple:
        setTitle(t('account:revokeAppleLogin'));
        break;
      default:
        setTitle(null);
        break;
    }
  }, [externalLoginType, t]);

  const revokeExternalLogin = async () => {
    try {
      await customersClient.removeExternalAuthentication(externalLoginType);
      onClose();
      triggerRelogin(t('account:externalLoginRevoked'));
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <Popup
        open={open}
        onClose={onClose}
        dialogTitle={title}
        dialogActions={
          <Stack direction="row" justifyContent="space-evenly" alignItems="center" sx={{ width: '100%' }}>
            <AccountConfirmButton onClick={() => onClose()} variant="contained">
              {t('account:confirmationNo')}
            </AccountConfirmButton>
            <AccountConfirmButton onClick={() => revokeExternalLogin()} variant="contained">
              {' '}
              {t('account:confirmationYes')}
            </AccountConfirmButton>
          </Stack>
        }
      />
      <ReloginConfirmation open={showReloginDialog} message={reloginMessage} onConfirm={handleReloginConfirm} />
    </>
  );
}
